export enum EDataType {
    SPEND = "spend",
    IMPRESSIONS = "impressions",
    VISITS = "visits",
    PAGE_VIEWS = "pageViews",
}

type DataPoint = {
    value: number;
    change: number;
};

type GranularBreakdownBase<T> = {
    spend: T;
    impressions: T;
};

type WithVisits<T> = GranularBreakdownBase<T> & { visits: T; pageViews?: never };
type WithPageViews<T> = GranularBreakdownBase<T> & { pageViews: T; visits?: never };

export type BreakdownByGranularity<T = DataPoint> = {
    [date: string]: WithVisits<T> | WithPageViews<T>;
};

export type PerformanceOverTimeResponse = {
    [key: string]: {
        daily: BreakdownByGranularity;
        weekly: BreakdownByGranularity;
        monthly: BreakdownByGranularity;
        total: BreakdownByGranularity<number>;
    };
};
